import { render } from "./RcsComponent.vue?vue&type=template&id=45cf2208&scoped=true"
import script from "./RcsComponent.vue?vue&type=script&lang=js"
export * from "./RcsComponent.vue?vue&type=script&lang=js"

import "./RcsComponent.vue?vue&type=style&index=0&id=45cf2208&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45cf2208"]])

export default __exports__